import { RootState } from "src/store";
import { connect } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";
import { TLabelOptionsType } from "../../filter-types";
import { useConfiguratorPageT } from "src/translation-hooks/configurator-page";
import { filterActions } from "../../filter-store";

const mapStateToProps = (state: RootState) => ({
  filterState: state.pageReducer.combinedConfiguratorReducer.filterReducer.filterState,
  formData: state.pageReducer.combinedConfiguratorReducer.filterReducer.formData
});

const ownActions = {
  setFormDataLabels: filterActions.setFormDataLabels
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const LabelsFilterBase = (props: Props) => {
  const { filterState, setFormDataLabels, formData } = props;

  const configuratorPageT = useConfiguratorPageT();

  const selectedLabels = formData.labels || [];

  const labels = useMemo(() => {
    if (filterState.loading === "has-loaded") {
      return filterState.data.labels;
    }
    return [];
  }, [filterState]);

  return (
    <>
      <Autocomplete
        value={selectedLabels
          .sort((a, b) => a.description.localeCompare(b.description))
          .filter(x => x.description && x.id)
          .map((x): TLabelOptionsType => ({ description: x.description || "", id: x.id || "" }))}
        onChange={(_, values) => {
          setFormDataLabels(values);
        }}
        getOptionDisabled={option => selectedLabels.some(selected => selected.id === option.id)}
        size="small"
        multiple
        options={labels
          .sort((a, b) => a.description.localeCompare(b.description))
          .filter(x => x.id && x.description)
          .map((x): TLabelOptionsType => ({ description: x.description, id: x.id }))}
        getOptionLabel={(option: TLabelOptionsType) => option.description || ""}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label={configuratorPageT.label} />}
      />
    </>
  );
};

export const LabelsFilter = connect(mapStateToProps, ownActions)(LabelsFilterBase);
